import { DefaultDashboardCard } from "./DefaultDashboardCard"

const Dashboard = () => {

    return (
        <DefaultDashboardCard children={undefined}/>
    )
}

export { Dashboard }